import Vue from 'vue'
import VueSocketio from 'vue-socket.io'
import store from '../store'
import { mainEventBus } from '../../../main';
const state = {
   // todo: delete after test
   acl_current: localStorage.getItem('acl_current'),
   // acl_current: "null",
   token: localStorage.getItem('token'),
   authTokenExpiration: localStorage.getItem('authTokenExpiration'),
   firstName: localStorage.getItem('firstName'),
   lastName: localStorage.getItem('lastName'),
   email: localStorage.getItem('email'),
   language: localStorage.getItem('language') || "de", // moved from previous line, suppose was there by mistake
   // roles
   roles: ['god4all', 'admin', 'client', 'user', 'client-admin', 'any'],
   defaultRole: 'any',
   aclRedirect: {
      'none': '/login',
      'any': '/login',
      'god4all': '/clients',
      'admin': '/clients',
      'user': '/',
      'client': '/',
      'client-admin': '/'
   }
};
const mutations = {
   'SET_STATE'(state, user) {
      if(user) {
         state.acl_current = user.hasOwnProperty('role') ? user.role : state.acl_current;
         state.firstName = user.hasOwnProperty('firstName') ? user.firstName : state.firstName;
         state.lastName = user.hasOwnProperty('lastName') ? user.lastName : state.lastName;
         state.email = user.hasOwnProperty('email') ? user.email : state.email;
         state.language = user.hasOwnProperty('language') ? user.language : state.language;
         state.token = user.hasOwnProperty('token') ? user.token : state.token;
         state.authTokenExpiration = user.hasOwnProperty('authTokenExpiration') ? user.authTokenExpiration : state.authTokenExpiration;
         // todo: delete after test
         if (user.role) localStorage.setItem('acl_current', user.role);
         if (user.firstName) localStorage.setItem('firstName', user.firstName);
         if (user.lastName) localStorage.setItem('lastName', user.lastName);
         if (user.email) localStorage.setItem('email', user.email);
         if (user.language) localStorage.setItem('language', user.language);
         if (user.token) localStorage.setItem('token', user.token);
         // todo: delete after test
         if (user.authTokenExpiration) localStorage.setItem('authTokenExpiration', user.authTokenExpiration);
      }
   },
   'LOG_OUT'(state) {
      state.acl_current = 'any';
      state.token = null;
      state.authTokenExpiration = null;
      state.firstName = null;
      state.lastName = null;
      state.email = null;
      state.language = null;
      localStorage.clear();
   },
   'SET_ACL'(state, permission){
      state.acl_current = permission;
   }
};

const actions = {
   logIn({commit}, user) {
      if(user && typeof(user) !== 'undefined') {
         commit('SET_STATE', user);
      } else {
         // console.log('TESTING LOG BUG', 'user NOT exists');
      }
      if(state.token) {
          const socket = io(mainEventBus.serverURL, {
              query: 'token=' + state.token
          }, store);

         Vue.use(VueSocketio, socket);
      }
   },
   logOut({commit}) {
      commit('LOG_OUT');
      router.go('/login');
   },
   removeLogged({commit}) {
      commit('LOG_OUT');
   },
   setUserData({commit}, user) {
      commit('SET_STATE', user);
   },
   setAcl({commit}, permission) {
      commit('SET_ACL', permission);
   }
};

const getters = {
   // todo: Niko: currently only used on my profile, we can change my profile to get data via socket/backend
   userData (state) {
      if(!state.language || typeof state.language == 'undefined' || state.language == 'undefined') { state.language = "en"; }
      var user = {
         token: state.token,
         authTokenExpiration: state.authTokenExpiration,
         firstName: state.firstName,
         lastName: state.lastName,
         email: state.email,
         language: state.language
      };
      return user;
   },
   getToken (state) {
      if (!state.token || !state.authTokenExpiration) { return null }
      return state.token;
   },
   // todo: Niko we can remove this maybe by using the acl stuff in component instead of mixin
   isLogged (state) {
      if (!state.token || !state.authTokenExpiration ) { return false }
      return true;
   },
   getDefaultLanguage (state) {
      if(!state.language || typeof state.language == 'undefined' || state.language == 'undefined') {
         state.language = "de";
      }

      return state.language;
   },
   getAclCurrent(state){
      return state.acl_current;
   },
   getRole(state){
      return state.acl_current;
   },
   getRoles (state) {
      return {
         roles: state.roles,
         defaultRole: state.defaultRole,
         aclRedirect: state.aclRedirect
      };
   }
};

export default {
   state,
   mutations,
   actions,
   getters
};




// WEBPACK FOOTER //
// ./src/Banet/store/modules/user.js